const setTimer = (date) => {
  const timerElement = document.querySelector("[data-timer]");
  if (!timerElement) return;

  (function timer() {
    // При изменении конечной даты в баннере вставляем сюда дату в формате (год, месяц[от 0 до 11], число, часы[от 0 до 23 и вычитаем разницу для Москвы], минуты, секунды)
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        23 - 3,
        59,
        0
      )
    );
    const countDownDate = new Date(utcDate).getTime();
    const timeInterval = setInterval(timer, 60000);
    const now = new Date().getTime();
    const distance = countDownDate - now;
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    const getMinutesWord = (minutes) => {
      let result = "минут";
      if (minutes > 10 && minutes < 20) {
        return result;
      }
      const lastDigit = Number(String(minutes).slice(-1));
      if (lastDigit === 0 || lastDigit >= 5) {
        return result;
      }
      if (lastDigit === 1) {
        return result + "а";
      }
      return result + "ы";
    };

    const getHoursWord = (hours) => {
      let result = "часов";
      if (hours > 10 && hours < 20) {
        return result;
      }
      const lastDigit = Number(String(hours).slice(-1));
      if (lastDigit === 0 || lastDigit >= 5) {
        return result;
      }
      if (lastDigit === 1) {
        return "час";
      }
      return "часа";
    };

    const getDaysWord = (days) => {
      let result = "дней";
      if (days > 10 && days < 20) {
        return result;
      }
      const lastDigit = Number(String(days).slice(-1));
      if (lastDigit === 0 || lastDigit >= 5) {
        return result;
      }
      if (lastDigit === 1) {
        return "день";
      }
      return "дня";
    };

    timerElement.innerHTML = `${days}&nbsp;${getDaysWord(
      days
    )}&nbsp;${hours}&nbsp;${getHoursWord(
      hours
    )}&nbsp;${minutes}&nbsp;${getMinutesWord(minutes)}`;

    if (distance < 0) {
      clearInterval(timeInterval);
      timerElement.innerHTML = `0&nbsp;дней&nbsp;0&nbsp;часов&nbsp;0&nbsp;минут`;
    }
  })();
};

export default setTimer;
